"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const input_1 = __importStar(require("../../../components/input/input"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const store_1 = require("../../../store");
const styles_1 = __importDefault(require("../../../styles/styles"));
const theme_1 = __importDefault(require("../../../styles/theme"));
const analytics_1 = require("../../../utils/analytics/analytics");
const choices_1 = require("../../../utils/choices");
const utils_1 = require("../../../utils/utils");
const businessOrganizationSlice_1 = require("../businessOrganization/businessOrganizationSlice");
const businessShareholdersConstants_1 = require("./businessShareholdersConstants");
const BusinessShareholderDetails = ({ businessShareholder, shareholders, setShareholders, setShowShareholdersComponent, setSelectedShareholder, setErrors, errors, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [shareholderFirstName, setShareholderFirstName] = (0, react_1.useState)(businessShareholder ? businessShareholder.first_name : '');
    const [shareholderLastName, setShareholderLastName] = (0, react_1.useState)(businessShareholder ? businessShareholder.last_name : '');
    const [shareholderPhoneNumber, setShareholderPhoneNumber] = (0, react_1.useState)(businessShareholder ? businessShareholder.phone_number : '');
    const [shareholderEmail, setShareholderEmail] = (0, react_1.useState)(businessShareholder ? businessShareholder.email : '');
    const [shareholderRole, setShareholderRole] = (0, react_1.useState)(businessShareholder ? businessShareholder.roles : '');
    const [shareholderAddress, setShareholderAddress] = (0, react_1.useState)(businessShareholder ? businessShareholder.application_home_address : '');
    const goBackToList = () => {
        setSelectedShareholder(undefined);
        setShowShareholdersComponent(businessShareholdersConstants_1.SHAREHOLDER_COMPONENT_LIST);
    };
    // Add or Edit bank account
    const submitShareholderForm = async () => {
        const payload = {
            user_id: businessShareholder ? businessShareholder.user_id : undefined,
            first_name: shareholderFirstName.toString(),
            last_name: shareholderLastName.toString(),
            phone_number: shareholderPhoneNumber.toString(),
            email: shareholderEmail.toString(),
            roles: shareholderRole.toString(),
            application_home_address: shareholderAddress.toString(),
        };
        const result = await dispatch((0, businessOrganizationSlice_1.submitBusinessShareholder)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'add_business_shareholder',
            status: 'submitted',
            location: 'screen_BusinessShareholderDetails',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'add_business_shareholder',
                status: 'success',
                location: 'screen_BusinessShareholderDetails',
            });
            setErrors(undefined);
            if (payload.user_id) {
                setShareholders(shareholders.map((el) => {
                    if (el.user_id === payload.user_id) {
                        return result.payload;
                    }
                    return el;
                }));
            }
            else {
                setShareholders(shareholders.concat(result.payload));
            }
            goBackToList();
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'add_business_shareholder',
                status: 'fail',
                location: 'screen_BusinessShareholderDetails',
            });
            setErrors(result.payload);
        }
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Shareholder First Name", placeholder: "Shareholder First Name", setValue: setShareholderFirstName, error: (0, utils_1.getError)('first_name', errors), value: shareholderFirstName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Shareholder Last Name", placeholder: "Shareholder Last Name", setValue: setShareholderLastName, error: (0, utils_1.getError)('last_name', errors), value: shareholderLastName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PHONE, label: "Shareholder Phone Number", setValue: setShareholderPhoneNumber, error: (0, utils_1.getError)('phone_number', errors), value: shareholderPhoneNumber }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Shareholder Email", placeholder: "Shareholder Email", setValue: setShareholderEmail, error: (0, utils_1.getError)('email', errors), value: shareholderEmail }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Shareholder Role", choices: choices_1.shareholderRoleChoices, setValue: setShareholderRole, value: shareholderRole || '', error: (0, utils_1.getError)('roles', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Shareholder Address", placeholder: "Shareholder Address", setValue: setShareholderAddress, error: (0, utils_1.getError)('application_home_address', errors), value: shareholderAddress }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
            react_1.default.createElement(primaryButton_1.default, { title: "SAVE SHAREHOLDER", onPress: submitShareholderForm, disabled: false, eventName: "save_business_shareholder" })),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
            react_1.default.createElement(primaryButton_1.default, { title: "CANCEL", onPress: goBackToList, disabled: false, eventName: "cancel_business_shareholder", color: theme_1.default.colors.COLOR_GRAY }))));
};
BusinessShareholderDetails.defaultProps = {
    businessShareholder: undefined,
    errors: undefined,
};
exports.default = BusinessShareholderDetails;
